<template>
  <div id="test">
    <!-- <pre>{{ testInitData }}</pre>
    <pre>{{ questionList }}</pre>-->
    <v-stepper
      v-model="testStep"
      :alt-labels="testInitData.alternative_labels"
      :vertical="testInitData.vertical"
    >
      <!-- dynamic test generation START -->
      <template v-if="testInitData.vertical">
        <template v-for="n in questionList">
          <v-stepper-step
            :ref="`step-${n.order_number}`"
            :key="`${n.global_id}-step`"
            :complete="n.answered"
            :step="n.order_number"
            :editable="testInitData.editable"
          >
            <span :class="n.correct ? 'green--text' : 'red--text'">
              Step {{ n.order_number }}
              <!-- <v-icon color="green" v-if="questions.q3">mdi-clipboard-check</v-icon> -->
            </span>
          </v-stepper-step>

          <v-stepper-content :key="`${n.global_id}-content`" :step="n.order_number">
            <v-card class="mb-12" color="grey lighten-1">
              <div v-if="n.type === 'yes-no'">
                <YesNo :qData="n"></YesNo>
              </div>
              <div v-if="n.type === 'singleChoice'">
                <!-- <SingleChoice :qData="n" @updateQuestion="n.user_answer"></SingleChoice> -->
                <SingleChoice :qData="n" v-model="n.user_answer"></SingleChoice>
                <!-- <pre>{{ n }}</pre> -->
              </div>
              <div v-else>
                <p>not supported yet</p>
                <!-- <pre>{{ n }}</pre> -->
              </div>
            </v-card>

            <v-btn color="primary" @click="nextStep(n)">Continue</v-btn>

            <v-btn text>Cancel</v-btn>
          </v-stepper-content>
        </template>
      </template>
      <template v-else>
        <v-stepper-header>
          <template v-for="n in questionList">
            <v-stepper-step
              :ref="`step-${n.order_number}`"
              :key="`${n.global_id}-step`"
              :complete="n.response.answered"
              :step="n.order_number"
              :editable="testInitData.editable"
              :rules="[() => n.response.correct === null || n.response.correct === true]"
            >Step {{ n.global_id }}</v-stepper-step>

            <v-divider
              v-if="n.order_number !== questionList.length"
              :key="`${n.global_id}-divider`"
            ></v-divider>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            v-for="n in questionList"
            :key="`${n.global_id}-content`"
            :step="n.order_number"
          >
            <v-card class="mb-12" color="grey lighten-1">
              <SingleChoice :qData="n" v-model="n.user_answer"></SingleChoice>
            </v-card>
            <!-- <pre>{{ n }}</pre> -->
            <v-btn color="primary" @click="nextStep(n)">Continue</v-btn>

            <!-- <v-btn text>Cancel</v-btn> -->
          </v-stepper-content>
        </v-stepper-items>
      </template>
    </v-stepper>
    <v-snackbar v-model="snackbar" :color="s_color" right :timeout="timeout" top>
      {{ snack_text }}
      <!-- <v-btn dark text @click="snackbar = false">Close</v-btn> -->
    </v-snackbar>
  </div>
</template>

<script>
import YesNo from '@/components/questionTypes/YesNo.vue';
import SingleChoice from '@/components/questionTypes/SingleChoice.vue';
// import MultipleChoice from '@/components/questionTypes/MultipleChoice.vue';
// import PairingList from '@/components/questionTypes/PairingList.vue';
// import Sentence from '@/components/questionTypes/Sentence.vue';
export default {
  components: {
    YesNo,
    SingleChoice,
    // MultipleChoice,
    // PairingList,
    // Sentence,
  },
  data() {
    return {
      e6: 1,
      e1: 0,
      testStep: 1,
      completeQ: 0,
      //snackbar config
      snackbar: false,
      timeout: 2000,
      s_color: '',
      snack_text: '',
      step: 1,
    };
  },
  computed: {
    completedTasks() {
      return this.qList.filter(q => q.answered).length;
    },
    progress() {
      return (this.completedTasks / this.qList.length) * 100;
    },
    remainingTasks() {
      return this.qList.length - this.completedTasks;
    },
    testInitData() {
      return this.$store.state.initialTestData.tequsDocument.info.theme.theme_setup.test;
    },
    questionList() {
      return this.$store.state.initialTestData.questionList;
    },
  },
  methods: {
    nextStep(n) {
      if (n.answered === false) {
        n.answered = true;
        this.completeQ++;
      }

      if (this.completeQ === this.questionList.length) {
        // alert('end Test');
        this.$router.push('results');
      }
      this.completeQuestion(n);
      this.cycleQuestions();
      // console.log(n);
    },
    completeQuestion(q) {
      if (q.user_answer === q.answer) {
        q.correct = true;

        // snackbar
        this.s_color = 'success';
        this.snackbar = true;
        this.snack_text = 'Nice!';
        return true;
      } else {
        q.correct = false;
        this.s_color = 'error';
        this.snackbar = true;
        this.snack_text = 'Nope!';
        return false;
      }
    },
    cycleQuestions() {
      this.testStep++;
      if (this.testStep > this.questionList.length) {
        this.testStep = 1;
      }
    },
  },
  watch: {
    step() {
      // My template is in a loop, so I use [0]...
      const comp = this.$refs[`step-${this.step}`][0];
      comp.$el.scrollIntoView();
    },
  },
};
</script>
